module.exports = __webpack_public_path__ + "static/media/myBnR_mini.23c8dcd8.png";